// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundles/" + __webpack_require__.h() + "/" + {"1869":"styles","2702":"element-web-app","5385":"init","5607":"error-view"}[chunkId] + ".css";
};